module.exports = __webpack_public_path__ + "assets/reorder-disabled.svg";